export default __webpack_public_path__ + "static/media/gem.c3c28c87.jpg";